import React from "react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { FloatingParticles } from "@/components/cyclospora/FloatingParticles";
import { Navbar } from "@/components/cyclospora/Navbar";
import { Hero } from "@/components/cyclospora/Hero";
import { HazardMarquee } from "@/components/cyclospora/HazardMarquee";
import { LoreSection } from "@/components/cyclospora/LoreSection";
import { OutbreakGlobe } from "@/components/cyclospora/OutbreakGlobe";
import { SymptomChecker } from "@/components/cyclospora/SymptomChecker";
import { FakeWarningPopups } from "@/components/cyclospora/FakeWarningPopups";
import { EasterEgg } from "@/components/cyclospora/EasterEgg";
import { Footer } from "@/components/cyclospora/Footer";
import { ErrorBoundary } from "@/components/cyclospora/ErrorBoundary";
import { GoogleNewsFeed } from "@/components/cyclospora/GoogleNewsFeed";

function App() {
  return (
    <div className="App">
      <div className="micro-bg" />
      <div className="grain" />

      <FloatingParticles />
      <Navbar />

      <main>
        <Hero />
        <HazardMarquee />
        <LoreSection />
        <HazardMarquee direction="right" />
        <ErrorBoundary
          fallback={
            <section id="globe" className="px-4 py-16 md:py-24 max-w-4xl mx-auto text-center">
              <h2 className="stencil text-4xl md:text-6xl">GLOBAL OUTBREAK TRACKER</h2>
              <div className="petri p-8 mt-6">
                <p className="font-mono2 text-white/80">
                  The outbreak globe needs WebGL, and your device just quarantined it. The parasite
                  spread everywhere anyway. Try a different browser to view the live tracker.
                </p>
              </div>
            </section>
          }
        >
          <OutbreakGlobe />
        </ErrorBoundary>
        <ErrorBoundary>
          <GoogleNewsFeed />
        </ErrorBoundary>
        <SymptomChecker />
      </main>

      <Footer />

      <FakeWarningPopups />
      <EasterEgg />
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
